module.exports = __webpack_public_path__ + "static/media/kop_surat.9e788731.png";